import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { OAuthStorage } from 'angular-oauth2-oidc';

import { iif, Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { EnumInjectionTokens } from '../constants';
import { IEnvironment } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class TokenHttpInterceptor implements HttpInterceptor {

  constructor(
    private authStorage: OAuthStorage,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  private addBearerTokenToRequest(req: HttpRequest<any>): HttpRequest<any> {
    const token = this.authStorage.getItem('access_token');
    const header = 'Bearer ' + token;

    const headers = req.headers.set('Authorization', header)
      .append('AuthorizationToken', header);

    return req.clone({ headers });
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const issuer: string = this.environment.authCodeFlowConfig.issuer || '';
    if (!issuer) throw Error('authCodeFlowConfig config missing');

    const isPingFed = req.url.toLocaleLowerCase().includes(issuer.toLocaleLowerCase());
    if (isPingFed) return next.handle(req);

    const isApiUrl = req.url.toLocaleLowerCase().includes(this.environment.base.apiUrl.toLocaleLowerCase());
    const apiUrl$ = of([this.environment.base.apiUrl]);

    return iif(() => isApiUrl, apiUrl$).pipe(
      concatMap(shouldAdd => {
        if (!shouldAdd) return next.handle(req);

        const newReq = this.addBearerTokenToRequest(req);
        return next.handle(newReq);
      })
    );
  }
}
